__turbopack_context__.v({
  "description": "SegmentedRadioGroup-module-scss-module__4wv-wq__description",
  "descriptionWrapper": "SegmentedRadioGroup-module-scss-module__4wv-wq__descriptionWrapper",
  "descriptionWrapperNoMargin": "SegmentedRadioGroup-module-scss-module__4wv-wq__descriptionWrapperNoMargin",
  "fade-in": "SegmentedRadioGroup-module-scss-module__4wv-wq__fade-in",
  "fieldset": "SegmentedRadioGroup-module-scss-module__4wv-wq__fieldset",
  "fullWidth": "SegmentedRadioGroup-module-scss-module__4wv-wq__fullWidth",
  "ghost": "SegmentedRadioGroup-module-scss-module__4wv-wq__ghost" + " " + "SegmentedRadioGroup-module-scss-module__4wv-wq__label",
  "group": "SegmentedRadioGroup-module-scss-module__4wv-wq__group",
  "item": "SegmentedRadioGroup-module-scss-module__4wv-wq__item",
  "label": "SegmentedRadioGroup-module-scss-module__4wv-wq__label",
  "labelNoMargin": "SegmentedRadioGroup-module-scss-module__4wv-wq__labelNoMargin",
  "legend": "SegmentedRadioGroup-module-scss-module__4wv-wq__legend",
  "meta": "SegmentedRadioGroup-module-scss-module__4wv-wq__meta",
  "no-transform": "SegmentedRadioGroup-module-scss-module__4wv-wq__no-transform",
  "option": "SegmentedRadioGroup-module-scss-module__4wv-wq__option",
  "radio": "SegmentedRadioGroup-module-scss-module__4wv-wq__radio",
  "rotate": "SegmentedRadioGroup-module-scss-module__4wv-wq__rotate",
});
